export const noticeData = {
  type: "string",
  minLength: 0,
  maxLength: Number.MAX_SAFE_INTEGER
};
